var levelOfAWSUsage = {
	"Level of AWS usage": "مستوى استخدام AWS",
	"Do not use AWS today": "لا تستخدم AWS اليوم",
	"Evaluating/experimenting with AWS": "تجربة/تقييم AWS",
	"Run dev/test workloads on AWS": "إجراء أعباء عمل اختبار التطوير على AWS",
	"Run a production workload on AWS": "إجراء عبء عمل إنتاجي واحد على AWS",
	"Run multiple production workloads on AWS": "إجراء أعباء عمل إنتاجية متعددة على AWS"
};

export { levelOfAWSUsage as default };
